export default __webpack_public_path__ + "static/media/social.bddf8555.png";